import ForgotPassword from "@features/login/pages/ForgotPassword";
import Login from "@features/login/pages/Login";
import ResetPassword from "@features/login/pages/ResetPassword";
import { getLoggedInUser } from "@utils/helpers";
import { Navigate } from "react-router-dom";

const UnprotectedRoute = ({ element }) => {
  const user = getLoggedInUser();
  const isAuthenticated = user && user.loggedIn;

  return isAuthenticated ? <Navigate to="/" /> : element;
};

const routes = [
  { path: "/login", element: <Login /> },
  { path: "/forgot_password", element: <ForgotPassword /> },
  { path: "/reset-password", element: <ResetPassword /> },
];

export const authRoutes = [
  ...routes.map((route) => {
    return {
      path: route.path,
      element: <UnprotectedRoute element={route.element} />,
    };
  }),
];
